import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {IValueSet, IValuesetItem} from '../interfaces/valueset.interface';

import {HttpInterceptorService} from '@ispm/core/services/http-interceptor.service';
import moment from "moment/moment";
import {get} from "lodash";

@Injectable()
export class ValuesetService {
  private readonly baseUrl = '/valueset';
  private activeValues = {active: 'Active', inactive: 'Inactive'};

  constructor(
    private _http: HttpInterceptorService
  ) {
  }

  getValuesetItems(valuesetName, locale, org_id, valuesOnly = false) {
    return this._http.get(this.baseUrl + `/${valuesetName}?auth_org_id=${org_id}&valuesOnly=${valuesOnly}&locale=${locale}`);
  }

  getLocalValuesetByName(valuesetName, owner, locale) {
    const headers = {
      auth_org_id: owner
    };

    return this._http.get(this.baseUrl + `/${valuesetName}?owner=${owner}&valuesOnly=false&locale=${locale}`, {}, true, headers);
  }

  updateValueSetValue(data) {
    const headers = {auth_org_id: data.owner};

    return this.updateValueSet(data, headers);
  }

  createValueSetValues(data) {
    const req = this._http.post(this.baseUrl, data, true)
      .map((res) => {
        return res;
      }).catch(err => {
        return Observable.throwError(err);
      }).publish();
    req.connect();

    return req;
  }

  getValuesetProvider(org) {
    const headers = {
      auth_org_id: org
    };

    return this._http.get('/contentProviders', {}, false, headers);
  }

  private updateValueSet(body, headers) {
    const req = this._http.put(this.baseUrl + '/update', body, true, headers)
      .map((res) => {
        return res.body;
      }).catch(err => {
        return Observable.throwError(err);
      }).publish();
    req.connect();

    return req;
  }

  getValueset(valuesetName: string): Observable<IValueSet> {
    return this._http.get(this.baseUrl + '/' + valuesetName + '?valuesOnly=false')
      .map(value => {
        if (value.body) {
          return value.body;
        } else {
          throw new Error('Http Response had null value');
        }
      });
  }

  public getValues(valueset, orgId): IValuesetItem[] {
    let valuePath = this.findValuePath(valueset);
    if (valuePath == null) {
      valuePath = 'define.concept';
    }
    let allValues: Array<any> = get(valueset, valuePath) || [];
    let ret: IValuesetItem[] = [];
    allValues.forEach(value => {
      const inactive = valueset.inactive && valueset.inactive.includes(value.code);
      value.isActive = inactive ? this.activeValues.inactive : this.activeValues.active;
      if (valueset.ontology) {
        value.source = valueset.ontology;
      } else if (value.owner) {
        value.source = (value.owner === orgId) ? 'Local' : 'Provider';
      } else {
        value.source = 'Default';
      }
      if (!value.externalCode) {
        value.externalCode = value.code;
      }
      ret.push(value);
    });
    return ret;
  }

  private findValuePath(vs) {
    const valuePaths = ['define.concept', 'compose.include[0].concept', 'codeSystem.concept', 'concept'];
    for (let i = 0; i < valuePaths.length; i++) {
      const path = valuePaths[i];
      const baseValues = get(vs, path);
      if (baseValues) {
        return path;
      }
    }
    return null;
  }
}
